import { Injectable } from '@angular/core';
import { TSFuntionService } from './ts-funtion.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  TimeoutCounting: string = "00:00";
  seconds = 0;
  SessionInterval: any; // Moved it out. 
  constructor(private System: TSFuntionService, private http: HttpClient) {
    //this.CreateTimeInterval();
  }

  CreateTimeInterval() {
    let ua = this.System.GetUserStorage();
    if (ua) {
      var CurrentDate = new Date();
      var UserExpire = Date.parse(ua.ExpireTime);
      var Diff = (UserExpire - CurrentDate.getTime()) / 1000;
      this.seconds = Math.ceil(Diff) - 20; //  ตั้งใจตัดออก 20 วิกัน Seesion หน้าบ้านไปต่อไม่ทัน
      this.SessionInterval = setInterval(() => this.SessionTimeout(), 1000);

      let sTextResult = "";
      sTextResult += "CurrentDate : " + CurrentDate.toString() + "\n";
      sTextResult += "UserExpire : " + ua.ExpireTime + "\n";
      sTextResult += "CurrentDateGetTime : " + CurrentDate.getTime() + "\n";
      sTextResult += "UserExpireGetTime : " + UserExpire + "\n";
      sTextResult += "Diff : " + Diff;
    }
  }

  SessionTimeout() {
    this.seconds--;
    var min = Math.floor(this.seconds / 60);
    var sec = Math.floor(this.seconds - (min * 60));
    this.TimeoutCounting = (min + "").padStart(2, '0') + ":" + (sec + "").padStart(2, '0');
    if (this.TimeoutCounting == "05:00") {

    }
    else if (this.TimeoutCounting == "00:00") {

    }

  }

  ConnectSession() {
    let This = this;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.http.post("api/SessionTimeOut/ConnectSession", {}, { headers, responseType: 'text' }).subscribe(res => {
      if (res) {

      }
      else {
        const httpOptions_User = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        };
        This.http.get<any>(This.System.SiteName + "api/_System/GetLoginStorage", httpOptions_User).subscribe(res => {
          if (res) {
            localStorage.removeItem(This.System.LoginKey);
            sessionStorage.setItem(This.System.LoginKey, JSON.stringify(res));
            clearInterval(this.SessionInterval);
            this.CreateTimeInterval();
          }
        });
      }
    });
  }

  ClearSession() {
    clearInterval(this.SessionInterval);
  }
}
